import { render } from "./GridHead.vue?vue&type=template&id=5a83e5ad&scoped=true&ts=true"
import script from "./GridHead.vue?vue&type=script&lang=ts"
export * from "./GridHead.vue?vue&type=script&lang=ts"

import "./GridHead.vue?vue&type=style&index=0&id=5a83e5ad&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a83e5ad"]])

export default __exports__